import { ConsoleMessageWriter, Logger } from '@instinet-analytics/core-lib';
import { LoggingService } from '@instinet-analytics/core-lib';
import { LogLevel } from '@instinet-analytics/core-lib';

export default function measure(
    source?: string
): (
    target: unknown,
    propertyKey: PropertyKey,
    propertyDescriptor: PropertyDescriptor
) => void {
    return (target, propertyKey, propertyDescriptor): void => {
        const originalMethod = propertyDescriptor.value;

        propertyDescriptor.value = async function (
            ...args: unknown[]
        ): Promise<unknown> {
            const start = new Date().getTime();
            try {
                return originalMethod.apply(this, args);
            } finally {
                const end = new Date().getTime();
                const ms = end - start;
                tryLog(this, source ?? propertyKey.toString(), ms);
            }
        };
    };
}

function tryLog(target: unknown, sourceP: string, ms: number) {
    const source = sourceP + ' [Measure]';
    const logger = (target as { logger?: Logger }).logger;
    if (logger?.debug) {
        logger.debug(`${source}: took ${ms}ms`);
        return;
    }
    const loggingService = (target as { loggingService?: LoggingService })
        .loggingService;
    if (loggingService?.debug) {
        loggingService.debug(source, `Took ${ms}ms`);
        return;
    }
    new ConsoleMessageWriter().writeMessage(
        LogLevel.Debug,
        source,
        `Took ${ms}ms`
    );
}
